import { ApiClient } from '../api-client';

const PayoutApi = ApiClient.service.payout;
/**
 *  usePayoutApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const usePayoutApi = () => {
  return PayoutApi;
};

export { PayoutApi, usePayoutApi };
